import { useListBlockedDomainsQuery } from '@frontend/api-url-shortner';

export const useBlockedShortenedDomains = (): { blockedDomains: string[] } => {
  const { data } = useListBlockedDomainsQuery({
    request: {},
    options: {
      staleTime: 1000 * 60 * 60, // 1 hour — blocked domain list changes rarely
    },
  });

  return { blockedDomains: data?.blockedDomains ?? [] };
};
